import React from 'react'
import ProgressBar from 'react-bootstrap/ProgressBar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRemove } from '@fortawesome/free-solid-svg-icons'

import { File, FileUploadState } from 'bundles/Pilot/types'
import Button from 'react-bootstrap/esm/Button'
import classNames from 'classnames'
import { useAppDispatch } from 'bundles/Pilot/hooks'
import { removeFile } from './slice'

type Props = {
  file: File
}

function FileUploadThumbnail({ file }: Props) {
  const dispatch = useAppDispatch()

  const remove = () => {
    if (confirm('Are you sure you want to remove this file?')) {
      dispatch(removeFile(file.clientId))
    }
  }

  const containerClasses = classNames({
    'pilot-file-upload-thumbnail': true,
    'text-danger': FileUploadState.UploadFailed === file.state,
  })

  return (
    <div className={containerClasses}>
      <div className='pilot-file-upload-thumbnail__container'>
        <div className='pilot-file-upload-thumbnail__filename'>{file.name}</div>
        <div className='pilot-file-upload-thumbnail__progress me-4'>
          {file.uploadError ? file.uploadError : null}
          {FileUploadState.Uploading === file.state ? (
            <>
              <ProgressBar now={file.progress || 0} animated variant='primary' />
              <div className='upload-progress-text'>{file.progress || 0}% uploaded</div>
            </>
          ) : null}
          {FileUploadState.Uploaded === file.state ? (
            <ProgressBar now={100} variant='success' />
          ) : null}
        </div>
      </div>
      <div className='pilot-file-upload-thumbnail__actions'>
        <Button size='sm' variant='outline-secondary' onClick={() => remove()}>
          <FontAwesomeIcon icon={faRemove} />
        </Button>
      </div>
    </div>
  )
}

export default FileUploadThumbnail
